import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {
    httpGenerateMedicalRecordCover,
    HttpGenerateMedicalRecordCoverOptions
} from '@/features/medical-records/http/medicalRecords.http'
import {MUTATION_KEYS} from '@/queryClient'
import {raise} from '@/utilities/helpers'

export const useGenerateMedicalRecordCover = (
    urlParams: HttpGenerateMedicalRecordCoverOptions['urlParams'],
    options?: Omit<UseMutationOptions, 'mutationFn' | 'mutationKey'>
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.GENERATE_MEDICAL_RECORD_COVER, urlParams],
        mutationFn: () =>
            httpGenerateMedicalRecordCover({
                urlParams: {medicalRecordId: urlParams?.medicalRecordId || raise('medicalRecordId is required')}
            })
    })
